import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
  },
  label: {
    marginLeft: '1px',
  },
}));
